import { render, staticRenderFns } from "./AddOrUpdateCanteenInventory.vue?vue&type=template&id=3410c941&scoped=true&"
import script from "./AddOrUpdateCanteenInventory.vue?vue&type=script&lang=ts&"
export * from "./AddOrUpdateCanteenInventory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3410c941",
  null
  
)

export default component.exports